import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { AppContextProvider } from 'context';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import TruckerProfileSkeleton from './trucker-profile-skeleton';

const ExposedTruckerProfileSkeleton = () => (
  <AppContextProvider>
    <ThemeProvider theme={dsTokens}>
      <TruckerProfileSkeleton />
    </ThemeProvider>
  </AppContextProvider>
);

export default ExposedTruckerProfileSkeleton;
